import { isEmptyArray, isNullOrUndefined, findRule } from '../Utils';

const validate = (vObj, { invalidateFalse = true } = {}) => {
  const { value } = vObj;
  const rule = findRule(vObj.errorBag, 'required');
  rule.feedback = `${vObj.fieldlabel} is required`;

  if (isNullOrUndefined(value) || isEmptyArray(value)) {
    return false;
  }

  // incase a field considers `false` as an empty value like checkboxes.
  if (value === false && !invalidateFalse) {
    return value;
  }

  return !!String(value).trim().length;
};

export { validate };

export default {
  validate,
};
